<template>
    <span>
        {{ value | time }}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ]
}
</script>
